import React from 'react';
import { ISbComponentType } from 'storyblok-js-client';
import { StringService } from '../services';
import { filterProps, slottedToComponents } from './helpers';
import { Props } from './types';

export const Default = ({ blok, getComponent, slot }: Props<ISbComponentType<string>>): JSX.Element => {
  const { props, slotted } = filterProps(blok);

  const allProps = {
    ...(blok.component === 'rcm-image' ? { 'include-margin-top': true } : {}),
    ...(blok.component === 'rcm-responsive-table' ? { 'include-no-wrap': false } : {}),
    ...(blok.component === 'rcm-video' ? { 'increased-margin-top': true } : {}),
    ...props,
    ...(slot ? { slot } : {}),
    // eslint-disable-next-line no-underscore-dangle
    ...(blok._uid ? { uid: blok._uid } : {}),
    // TODO: remove section_id option after SB schema migration is done
    // eslint-disable-next-line no-underscore-dangle
    ...(blok.id || blok.section_id || blok._uid ? { id: blok.id || blok.section_id || blok._uid } : {}),
  };

  const CustomComponent = StringService.camelToKebab(blok.component) as React.ElementType;
  let children: (JSX.Element | JSX.Element[])[];

  if (blok.component.startsWith('oh')) {
    children = slottedToComponents(getComponent, slotted, true);
  } else {
    children = slottedToComponents(getComponent, slotted);
  }

  return <CustomComponent {...allProps}>{children}</CustomComponent>;
};
